"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalAttributeDisplayTypes = exports.DynamicApprovalAttributeTypes = exports.ApprovalAttributeSources = void 0;
var ApprovalAttributeSources;
(function (ApprovalAttributeSources) {
    /**
     * Came directly from database on the parent Approval record
     */
    ApprovalAttributeSources["approval"] = "approval";
    /**
     * Came directly from database directly on the Approval Option record
     */
    ApprovalAttributeSources["approvalOption"] = "approvalOption";
    /**
     * Is calculated based on values of other Attributes
     */
    ApprovalAttributeSources["calculation"] = "calculation";
    /**
     * Attribute value be directly changed by UI input
     */
    ApprovalAttributeSources["userInput"] = "userInput";
})(ApprovalAttributeSources || (exports.ApprovalAttributeSources = ApprovalAttributeSources = {}));
/**
 * Describes whether a NumericApprovalAttribute with a dynamic value
 * is a range limited by boundaries or a statically provided set of
 * selection values
 */
var DynamicApprovalAttributeTypes;
(function (DynamicApprovalAttributeTypes) {
    /**
     * A range described by min and max boundaries
     */
    DynamicApprovalAttributeTypes["range"] = "range";
    /**
     * A distinct set of numeric values, basically Array<number>
     */
    DynamicApprovalAttributeTypes["numericSet"] = "numericSet";
    /**
     * A distinct array of objects matching the interface:
     * {label: string, value: number | string}
     * (AttributeLabeledOption)
     */
    DynamicApprovalAttributeTypes["labeledSet"] = "labeledSet";
})(DynamicApprovalAttributeTypes || (exports.DynamicApprovalAttributeTypes = DynamicApprovalAttributeTypes = {}));
var ApprovalAttributeDisplayTypes;
(function (ApprovalAttributeDisplayTypes) {
    ApprovalAttributeDisplayTypes["currency"] = "currency";
    ApprovalAttributeDisplayTypes["percent"] = "percent";
    ApprovalAttributeDisplayTypes["number"] = "number";
})(ApprovalAttributeDisplayTypes || (exports.ApprovalAttributeDisplayTypes = ApprovalAttributeDisplayTypes = {}));
